import React, { Component } from 'react';
import { Container, Row, Col, Table, Button, Alert } from 'react-bootstrap';
import AppSpinner from '../AppSpinner/AppSpinner';
import apiUrl from '../../utils/apiUrl';
import { hideArticleCreatedNotification, hideArticleDeletedNotification} from '../../redux/modules/notifications';
import { connect } from 'react-redux';
import './styles/styles.scss';

const select = state => {
  return {
    token: state.auth.token,
    showArticleCreatedNotification: state.notifications.showArticleCreated,
    showArticleDeletedNotification: state.notifications.showArticleDeleted
  };
};

function mapDispatchToProps(dispatch) {
  return {
    hideArticleCreatedNotification: () => dispatch(hideArticleCreatedNotification()),
    hideArticleDeletedNotification: () => dispatch(hideArticleDeletedNotification())
  };
}

class ConnectedBlogComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      articles: []
    };
  }

  async componentDidMount() {
    
    const { token } = this.props;
    const articlesResponse = await fetch(`${apiUrl}/admin/blog/all?token=${token}`);
    const articlesJson = await articlesResponse.json();

    if (articlesJson.success) this.setState({ articles: articlesJson.articles });

    this.setState({ isLoading: false });
  }

  render() {

    const { articles, isLoading } = this.state;
    const {
      history,
      showArticleCreatedNotification,
      showArticleDeletedNotification,
      hideArticleCreatedNotification,
      hideArticleDeletedNotification
    } = this.props;

    if (isLoading) return (<AppSpinner />);

    return (
      <div className="table-info-component blog-component">
        <Container>
          <Row>
            <Col xs={12}>

              {
                showArticleCreatedNotification &&
                <Alert variant="info" onClose={hideArticleCreatedNotification} dismissible>
                  <p>
                    El artículo se creó correctamente.
                  </p>
                </Alert>
              }

              {
                showArticleDeletedNotification &&
                <Alert variant="info" onClose={hideArticleDeletedNotification} dismissible>
                  <p>
                    El artículo se eliminó correctamente.
                  </p>
                </Alert>
              }

              <h1 className="header">Blog</h1>
            </Col>

            <Col xs={12}>
              <Button
                className="create-article-btn"
                variant="primary"
                onClick={() => {
                  history.push(`/blog/nuevo`);
                }}
              >
                Nuevo artículo
              </Button>
            </Col>

            <Col xs={12}>

              {
                !articles.length ? <p>No hay artículos.</p> :
              
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Título</th>
                      <th>Resumen</th>
                      <th>Editar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      articles.map((article, index) =>
                        <tr key={article._id}>
                          <td>{index + 1}</td>
                          <td>{article.title}</td>
                          <td>{article.abstract}</td>
                          <td>
                            <Button
                              variant="info"
                              size="sm"
                              onClick={() => {
                                history.push(`/blog/${article._id}`);
                              }}
                            >
                              Editar
                            </Button>
                          </td>
                        </tr>
                      )
                    }
                  </tbody>
                </Table>
              }
              
            </Col>

          </Row>
        </Container>
      </div>
    );
  }
}

const BlogComponent = connect(select, mapDispatchToProps)(ConnectedBlogComponent);

export default BlogComponent;
